import { useEventId, usePresenceId } from "pages/events"
import { useDiagnosticForm, useExecutionDiagnosticForm } from "../../queries"
import Loader from "components/loader"
import styles from "./styles.module.scss"
import "survey-react/modern.min.css"
import { IEvent } from "pages/events/types"
import { UseQueryResult } from "@tanstack/react-query"
import { useMemo } from "react"
import DiagnosticResult from "components/diagnostic-result"

const Diagnostic: React.FC<{ event: UseQueryResult<IEvent> }> = ({ event }) => {
  const presenceId = usePresenceId() // or memberId
  const eventId = useEventId()
  const executionDiagnostic = useExecutionDiagnosticForm(
    eventId!,
    presenceId!,
    {
      enabled: event.data?.status === "execution",
    }
  )
  const memberDiagnostic = useDiagnosticForm(eventId!, presenceId!, {
    enabled: event.data?.status === "approved",
  })

  const { data, isLoading } = useMemo(
    () =>
      event.data?.status === "execution"
        ? executionDiagnostic
        : memberDiagnostic,
    [executionDiagnostic, memberDiagnostic]
  )

  return (
    <>
      {event.isLoading || isLoading ? (
        <Loader />
      ) : (
        <div>
          <div className={styles.surveyContainer}>
            <DiagnosticResult
              formDefinition={data?.form_definition}
              formAnswers={data?.answer_content}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default Diagnostic
